export default {
  SET_INSURANCE_AMOUNT: "SET_INSURANCE_AMOUNT",
  SET_INSURANCE_PAYPLE_INFO: "SET_INSURANCE_PAYPLE_INFO",
  SET_INSURANCE_TYPE: "SET_INSURANCE_TYPE",
  SET_INSURANCE_ERROR: "SET_INSURANCE_ERROR",
  SET_INSURANCE_META: "SET_INSURANCE_META",
  SET_INSURANCE_REGISTER: "SET_INSURANCE_REGISTER",
  SET_INSURANCE_REGISTER_DATE: "SET_INSURANCE_REGISTER_DATE",
  SET_INSURANCE_RESET_REGISTER: "SET_INSURANCE_RESET_REGISTER",
  SET_INSURANCE_ITEM: "SET_INSURANCE_ITEM",
};

export const initialRegisterState = {
  /** @type {string | null} 보험 상품 타입 */
  insurance_type: null,

  /** @type {string | null} 월납 / 일시납 타입 (one_time | monthly) */
  payment_type: null,

  /** @type {string | null} PG사 결제용 고유번호*/
  merchant_uid: null,

  /** @type {string | null} PG사 이름 (ex:  payple, kakao) */
  pg_name: null,

  /** @type {number | null} 본인인증 결과 고유번호 */
  user_verify_seq: null,

  /** @type {string | null} 계약 시작일 */
  contract_start_date: null,

  /** @type {string | null} 계약 종료일 */
  contract_end_date: null,

  /** @type {string | null} 계약 타입 */
  contract_type: null,

  /** @type {number} 보증금 */
  deposit_amount: 0,

  /** @type {number} 월세 금액 */
  rental_amount: 0,

  /** @type {string | null} 도로명 주소 */
  address: null,

  /** @type {string | null} 지번 주소 */
  address_jibun: null,

  /** @type {string | null} 시 */
  address_si: null,

  /** @type {string | null} 구 */
  address_gu: null,

  /** @type {string | null} 동 */
  address_dong: null,

  /** @type {string | null} 리 */
  address_li: null,

  /** @type {string | null} 건물명 */
  building_name: null,

  /** @type {string | null} 건물 코드 */
  building_code: null,

  /** @type {string | null} 건물 번호 */
  building_number: null,

  /** @type {string | null} 건물 동 */
  building_dong: null,

  /** @type {string | null} 건물 호 */
  building_ho: null,

  /** @type {string | null} 건물 층 */
  building_floor: null,

  /** @type {string | null} 쿠폰 관련 코드드 */
  code: null,

  /** @type {number} 결제 금액 */
  price: 0,

  /** @type {number | null} 리포트 고유번호 - 보험 가입시 연계용 */
  report_seq: null,

  /** @type {number | null} 구독 고유번호 - 보험 가입시 연계용 */
  subscribe_seq: null,
};

export const initialMetaState = {
  /** @type {string | null} 주소 */
  address: null,

  /** @type {string | null} 건물 동 */
  building_dong: null,

  /** @type {string | null} 건물 층 */
  building_floor: null,

  /** @type {string | null} 건물 호 */
  building_ho: null,

  /** @type {string | null} 건물 명 */
  building_name: null,

  /** @type {string | null} 거주 계약 기간 */
  contract_date: null,

  /** @type {boolean | null} 보험 존재 여부 */
  exists: null,

  /** @type {number | null} 구독상세(analyze) 고유번호 */
  id: null,

  /** @type {number | null} 보험 고유번호 */
  insurance_seq: null,

  /** @type {string | null} 보험 상태 */
  status: null,

  /** @type {string | null} 구독 변동 일자 */
  status_date: null,

  /** @type {number | null} 구독 고유번호 */
  subscribe_seq: null,

  /** @type {string | null} 구독 상태 */
  subscribe_status: null,

  /** @type {string | null} 구독 변동 타입 */
  view_type: null,

  /** @type {string | null} 일시납/월납 */
  payment_type: null,

  /** @type {boolean | null} 첫달무료 여부 */
  free_month: false,

  /** @type {string | null} 첫달무료 종료일 - YYYY-MM-DD */
  free_month_until: null,
};

/**
 * @typedef {'lotte_legal_001'} InsuranceType
 * @typedef {'정상' | '취소' | '철회' | '해지' | '변경'} InsuranceStatusKr
 * @typedef {'pending' | 'review' | 'confirm' | 'reject' | 'cancel'} InsuranceInternalStatus
 */
export const initialItemState = {
  /** @type {number | null} 보험 고유번호 */
  insurance_seq: null,

  /** @type {number | null} 구독 고유번호 */
  subscribe_seq: null,

  /** @type {InsuranceType | null} 보험 종류 */
  insurance_type: null,

  /** @type {string | null} 일시납/월납 */
  payment_type: null,

  /** @type {boolean | null} 첫달무료 여부 */
  free_month: false,

  /** @type {string | null} 첫달무료 종료일 - YYYY-MM-DD */
  free_month_until: null,

  /** @type {InsuranceStatusKr | null} 보험 상태 */
  insurance_status: null,

  /** @type {InsuranceInternalStatus | null} 보험 가입 절차 상태 */
  status: null,

  /** @type {{ start_date: string | null, end_date: string | null }} 계약 기간 */
  contract_duration: {
    start_date: null,
    end_date: null,
  },

  /** @type {{ file_url: string | null }} 보험 가입 증서 */
  insurance_certificate: {
    file_url: null,
  },

  /** @type {{ user_name: string | null, address: string | null }} 보엄 내용 상세 */
  detail: {
    user_name: null,
    address: null,
  },
};
